<section>
  <app-breadcrumb label="Reportes"></app-breadcrumb>

  <div class="section__main section__main--reports">
    <div class="section__title pb-15">
      <h1>Reporte de trazabilidad de vendedores</h1>
    </div>
    
    <div class="reports">
      <div class="reports__tableComp">
        <div class="reports__table table--fullHeight table--fullAdaptable">
          
          <!-- Header -->
          <div class="reports__tableHeader">
            <h3>Trazabilidad de vendedores</h3>
          </div>

          <!-- Filters -->
          <div class="reports__tableFilters">
            <div class="filters__date filters__date--row">
              <div class="filters__title">
                <h4>Filtrar por período</h4>
              </div>
              <div class="filters__dateBlock">
                <div class="filters__dateGroup">
                  <div class="filters__dateField">
                    <label class="filters__dateLabel">Desde:</label>
                    <p-calendar [(ngModel)]="startDate" inputId="seller-traceability-start-date" panelStyleClass="filters__dateCustom" appendTo="body" dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" placeholder="Seleccionar..." styleClass="filters__dateCalendar"></p-calendar>
                  </div>

                  <div class="filters__dateField">
                    <label class="filters__dateLabel">Hasta:</label>
                    <p-calendar [(ngModel)]="endDate" inputId="seller-traceability-end-date" panelStyleClass="filters__dateCustom" appendTo="body" dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" placeholder="Seleccionar..." styleClass="filters__dateCalendar"></p-calendar>
                  </div>
                </div>

                <div class="filters__dateActions">
                  <div class="filters__dateButton">
                    <button pButton pRipple label="Filtrar" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow" (click)="filter()"></button>
                  </div>
                  <div class="filters__dateButton">
                    <p-button label="Limpiar" icon="pi pi-trash" iconPos="right" [text]="true" [plain]="true" (click)="clearFilters()"></p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Datatable -->
          <div class="reports__tableDatatable">
            <p-table [value]="filteredList" [rows]="rows"  [rowsPerPageOptions]="[15, 30, 50]"  [paginator]="true"  [loading]="loading"  [showCurrentPageReport]="true"  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [scrollable]="true">
              
              <ng-template pTemplate="header">
                <!-- Titles -->
                <tr class="p-datatable-titles">
                  <th pSortableColumn="date" style="min-width: 9.6875rem">
                    <div class="th-title">
                      <span>Fecha</span>
                      <p-sortIcon field="date"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="credit_number" style="min-width: 9.6875rem">
                    <div class="th-title">
                      <span>Número de Crédito</span>
                      <p-sortIcon field="credit_number"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="customer_number" style="min-width: 9.6875rem">
                    <div class="th-title">
                      <span>Número de Cliente</span>
                      <p-sortIcon field="customer_number"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="document" style="min-width: 9.6875rem">
                    <div class="th-title">
                      <span>Cédula</span>
                      <p-sortIcon field="document"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="first_name" style="min-width: 10rem">
                    <div class="th-title">
                      <span>Nombres</span>
                      <p-sortIcon field="first_name"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="last_name" style="min-width: 10rem">
                    <div class="th-title">
                      <span>Apellidos</span>
                      <p-sortIcon field="last_name"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="initial_seller" style="min-width: 10.625rem">
                    <div class="th-title">
                      <span>Vendedor que inició la venta</span>
                      <p-sortIcon field="initial_seller"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="continuation_seller" style="min-width: 10.625rem">
                    <div class="th-title">
                      <span>Vendedor que continuó la venta</span>
                      <p-sortIcon field="continuation_seller"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="status" style="min-width: 10.625rem">
                    <div class="th-title">
                      <span>Estado</span>
                      <p-sortIcon field="status"></p-sortIcon>
                    </div>
                  </th>
                </tr>

                <!-- Filter Titles -->
                <tr class="p-datatable-filters">
                  <th>
                    <div class="th-filter">
                      <p-calendar [(ngModel)]="columnFilters.date" dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true" styleClass="p-datatable-filters__columnDatePicker" panelStyleClass="filters__dateCustom" appendTo="body" (onSelect)="applyColumnFilters()" (onClear)="applyColumnFilters()"></p-calendar>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <span class="p-input-icon-right p-datatable-filters__columnSearch">
                        <input pInputText type="text" [(ngModel)]="columnFilters.credit_number" (input)="applyColumnFilters()" />
                        <i class="pi pi-search"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <span class="p-input-icon-right p-datatable-filters__columnSearch">
                        <input pInputText type="text" [(ngModel)]="columnFilters.customer_number" (input)="applyColumnFilters()" />
                        <i class="pi pi-search"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <span class="p-input-icon-right p-datatable-filters__columnSearch">
                        <input pInputText type="text" [(ngModel)]="columnFilters.document" (input)="applyColumnFilters()" />
                        <i class="pi pi-search"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <span class="p-input-icon-right p-datatable-filters__columnSearch">
                        <input pInputText type="text" [(ngModel)]="columnFilters.first_name" (input)="applyColumnFilters()" />
                        <i class="pi pi-search"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <span class="p-input-icon-right p-datatable-filters__columnSearch">
                        <input pInputText type="text" [(ngModel)]="columnFilters.last_name" (input)="applyColumnFilters()" />
                        <i class="pi pi-search"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <span class="p-input-icon-right p-datatable-filters__columnSearch">
                        <input pInputText type="text" [(ngModel)]="columnFilters.initial_seller" (input)="applyColumnFilters()" />
                        <i class="pi pi-search"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <span class="p-input-icon-right p-datatable-filters__columnSearch">
                        <input pInputText type="text" [(ngModel)]="columnFilters.continuation_seller" (input)="applyColumnFilters()" />
                        <i class="pi pi-search"></i>
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="th-filter">
                      <p-dropdown [options]="statusOptions" [(ngModel)]="columnFilters.status" optionLabel="label" optionValue="value" placeholder="Todos" styleClass="p-datatable-filters__columnDropdown" (onChange)="applyColumnFilters()"></p-dropdown>
                    </div>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr class="p-datatable-content">
                  <td>
                    <div class="td-text">
                      <p>{{ row.date | date: 'dd/MM/yyyy' }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <p class="upper strong">{{ row.credit_number }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <p class="upper">{{ row.customer_number }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <p>{{ row.document }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <p>{{ row.first_name }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <p>{{ row.last_name }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <p>{{ row.initial_seller }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <p>{{ row.continuation_seller }}</p>
                    </div>
                  </td>
                  <td>
                    <div class="td-text">
                      <div class="status-tag" [ngClass]="row.statusClass">
                        <span>{{ row.status }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr class="p-datatable-content">
                  <td colspan="9">
                    <div class="td-empty">
                      <p>No se encontraron resultados para mostrar.</p>
                    </div>
                  </td>
                </tr>
              </ng-template>

            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
